<template>
  <svg
    :class="size"
    viewBox="0 0 275 197"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M137.31 196.5C191.572 196.5 235.56 152.512 235.56 98.2501C235.56 43.9881 191.572 0 137.31 0C83.0481 0 39.0601 43.9881 39.0601 98.2501C39.0601 152.512 83.0481 196.5 137.31 196.5Z"
      :fill="bgColor"
    />
    <g filter="url(#filter0_d_4516_40134)">
      <g filter="url(#filter1_b_4516_40134)">
        <path
          d="M71.8936 73.9453H260.032C261.88 73.9453 263.652 74.6794 264.959 75.9862C266.266 77.293 267 79.0654 267 80.9134V115.754C267 117.602 266.266 119.374 264.959 120.681C263.652 121.988 261.88 122.722 260.032 122.722H71.8936C70.0456 122.722 68.2732 121.988 66.9664 120.681C65.6597 119.374 64.9255 117.602 64.9255 115.754V80.9134C64.9255 79.0654 65.6597 77.293 66.9664 75.9862C68.2732 74.6794 70.0456 73.9453 71.8936 73.9453V73.9453Z"
          fill="white"
          fill-opacity="0.8"
        />
      </g>
    </g>
    <path
      d="M175.021 85.0947H138.787C136.478 85.0947 134.606 86.9666 134.606 89.2756C134.606 91.5846 136.478 93.4564 138.787 93.4564H175.021C177.33 93.4564 179.202 91.5846 179.202 89.2756C179.202 86.9666 177.33 85.0947 175.021 85.0947Z"
      :fill="$primaryColor"
    />
    <path
      d="M200.106 103.212H138.787C136.478 103.212 134.606 105.084 134.606 107.393C134.606 109.702 136.478 111.574 138.787 111.574H200.106C202.415 111.574 204.287 109.702 204.287 107.393C204.287 105.084 202.415 103.212 200.106 103.212Z"
      :fill="bgColor"
    />
    <path
      d="M107.431 111.574C114.743 111.574 120.67 105.647 120.67 98.3351C120.67 91.0232 114.743 85.0957 107.431 85.0957C100.119 85.0957 94.1917 91.0232 94.1917 98.3351C94.1917 105.647 100.119 111.574 107.431 111.574Z"
      :fill="bgColor"
    />
    <g filter="url(#filter2_d_4516_40134)">
      <g filter="url(#filter3_b_4516_40134)">
        <path
          d="M11.9682 133.87H200.107C201.955 133.87 203.727 134.604 205.034 135.911C206.341 137.218 207.075 138.99 207.075 140.838V175.679C207.075 177.527 206.341 179.299 205.034 180.606C203.727 181.913 201.955 182.647 200.107 182.647H11.9682C10.1202 182.647 8.3478 181.913 7.04103 180.606C5.73426 179.299 5.00012 177.527 5.00012 175.679V140.838C5.00012 138.99 5.73426 137.218 7.04103 135.911C8.3478 134.604 10.1202 133.87 11.9682 133.87V133.87Z"
          fill="white"
          fill-opacity="0.8"
        />
      </g>
    </g>
    <path
      d="M115.096 145.02H78.8619C76.5529 145.02 74.681 146.891 74.681 149.2C74.681 151.509 76.5529 153.381 78.8619 153.381H115.096C117.405 153.381 119.277 151.509 119.277 149.2C119.277 146.891 117.405 145.02 115.096 145.02Z"
      :fill="$primaryColor"
    />
    <path
      d="M140.181 163.137H78.862C76.553 163.137 74.6812 165.009 74.6812 167.318C74.6812 169.627 76.553 171.498 78.862 171.498H140.181C142.49 171.498 144.362 169.627 144.362 167.318C144.362 165.009 142.49 163.137 140.181 163.137Z"
      :fill="bgColor"
    />
    <path
      d="M29.3884 171.499C36.7003 171.499 42.6278 165.572 42.6278 158.26C42.6278 150.948 36.7003 145.021 29.3884 145.021C22.0765 145.021 16.149 150.948 16.149 158.26C16.149 165.572 22.0765 171.499 29.3884 171.499Z"
      :fill="bgColor"
    />
    <g filter="url(#filter4_d_4516_40134)">
      <g filter="url(#filter5_b_4516_40134)">
        <path
          d="M200.107 14.0195H11.9681C8.11972 14.0195 5 17.1393 5 20.9876V55.8281C5 59.6764 8.11972 62.7962 11.9681 62.7962H200.107C203.955 62.7962 207.075 59.6764 207.075 55.8281V20.9876C207.075 17.1393 203.955 14.0195 200.107 14.0195Z"
          fill="white"
          fill-opacity="0.8"
        />
      </g>
    </g>
    <path
      d="M112.309 25.1689H76.0747C73.7656 25.1689 71.8938 27.0408 71.8938 29.3498C71.8938 31.6588 73.7656 33.5307 76.0747 33.5307H112.309C114.618 33.5307 116.49 31.6588 116.49 29.3498C116.49 27.0408 114.618 25.1689 112.309 25.1689Z"
      :fill="$primaryColor"
    />
    <path
      d="M137.394 43.2861H76.0747C73.7656 43.2861 71.8938 45.158 71.8938 47.467C71.8938 49.776 73.7656 51.6478 76.0747 51.6478H137.394C139.703 51.6478 141.575 49.776 141.575 47.467C141.575 45.158 139.703 43.2861 137.394 43.2861Z"
      :fill="bgColor"
    />
    <path
      d="M47.5054 51.6487C54.8173 51.6487 60.7447 45.7212 60.7447 38.4093C60.7447 31.0974 54.8173 25.1699 47.5054 25.1699C40.1935 25.1699 34.266 31.0974 34.266 38.4093C34.266 45.7212 40.1935 51.6487 47.5054 51.6487Z"
      :fill="bgColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M51.6346 43.0301C51.6329 42.8199 51.5436 42.6031 51.3847 42.4442L51.3848 42.4559C51.2317 42.3029 51.015 42.2136 50.7989 42.206L45.7764 42.1662L52.4968 35.4458C52.8155 35.1272 52.8172 34.6075 52.4876 34.2779C52.1639 33.9542 51.6383 33.9501 51.3197 34.2687L44.6116 40.9768L44.5719 35.9674C44.5702 35.7572 44.4809 35.5405 44.322 35.3815L44.3157 35.3996C44.1627 35.2466 43.946 35.1573 43.7299 35.1497L43.724 35.1438C43.2685 35.1402 42.8977 35.511 42.9071 35.9607L42.9077 35.9601L42.9632 42.9674C42.9651 43.2025 43.0599 43.4131 43.2123 43.5641C43.3634 43.7167 43.5726 43.81 43.8047 43.8089L50.812 43.8644L50.8178 43.8586C51.2733 43.8622 51.6441 43.4915 51.6346 43.0301Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.2946 162.24C33.2929 162.03 33.2036 161.813 33.0447 161.654L33.0448 161.666C32.8918 161.513 32.675 161.424 32.4589 161.416L27.4365 161.376L34.1569 154.656C34.4755 154.337 34.4772 153.818 34.1476 153.488C33.8239 153.164 33.2984 153.16 32.9797 153.479L26.2716 160.187L26.2319 155.177C26.2303 154.967 26.141 154.75 25.9821 154.592L25.9758 154.61C25.8227 154.457 25.606 154.367 25.3899 154.36L25.384 154.354C24.9285 154.35 24.5578 154.721 24.5672 155.171L24.5677 155.17L24.6232 162.177C24.6251 162.412 24.7199 162.623 24.8724 162.774C25.0234 162.927 25.2326 163.02 25.4647 163.019L32.4721 163.074L32.4779 163.069C32.9333 163.072 33.3041 162.701 33.2946 162.24Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M103.016 93.7619C103.017 93.9721 103.107 94.1889 103.266 94.3478L103.266 94.3361C103.419 94.4891 103.635 94.5784 103.852 94.586L108.874 94.6258L102.154 101.346C101.835 101.665 101.833 102.184 102.163 102.514C102.487 102.838 103.012 102.842 103.331 102.523L110.039 95.8152L110.078 100.825C110.08 101.035 110.169 101.252 110.328 101.41L110.335 101.392C110.488 101.545 110.704 101.635 110.921 101.642L110.926 101.648C111.382 101.652 111.753 101.281 111.743 100.831L111.743 100.832L111.687 93.8246C111.685 93.5895 111.591 93.3789 111.438 93.2278C111.287 93.0753 111.078 92.982 110.846 92.9831L103.838 92.9276L103.833 92.9334C103.377 92.9298 103.006 93.3005 103.016 93.7619Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_4516_40134"
        x="62.9255"
        y="71.9453"
        width="212.075"
        height="58.7764"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="3" />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4516_40134"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4516_40134"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_b_4516_40134"
        x="44.9255"
        y="53.9453"
        width="242.075"
        height="88.7764"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_4516_40134"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_4516_40134"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_4516_40134"
        x="0.00012207"
        y="131.87"
        width="212.075"
        height="58.7764"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4516_40134"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4516_40134"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_b_4516_40134"
        x="-14.9999"
        y="113.87"
        width="242.075"
        height="88.7764"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_4516_40134"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_4516_40134"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_4516_40134"
        x="0"
        y="12.0195"
        width="212.075"
        height="58.7764"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4516_40134"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4516_40134"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_b_4516_40134"
        x="-15"
        y="-5.98047"
        width="242.075"
        height="88.7764"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_4516_40134"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_4516_40134"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    bgColor () {
      return this.$primaryColor === '#F26722' ? '#FEF0E9' : '#D0E3FC'
    }
  }
}
</script>
